import { useSelector } from "react-redux";
import ProductCard from "./ProductCard";
import { useOrderAnimations, prefersReducedMotion } from "./orders.animations";

const ProductGrid = ({ search }) => {
  const { products } = useSelector(state => state.products);
  const { selected } = useSelector(state => state.categories);

  // The stylesheet the cards and the cart both use. Injected once, whichever
  // of them mounts first.
  useOrderAnimations();

  const filtered = products.filter(p => {
    const matchesSearch = p?.name?.toLowerCase().includes(search?.toLowerCase());
    const matchesCategory = selected === "All" || p.category === selected;
    return matchesSearch && matchesCategory;
  });

  /**
   * Changing category or typing in the search box deals the menu out again,
   * card after card.
   *
   * The `key` is what makes that possible: a new key is a new grid as far as
   * React is concerned, so every card mounts afresh and its entrance animation
   * runs. Tapping a card does NOT change this key, so a menu does not reshuffle
   * itself under the finger while an order is being rung in.
   */
  const deal = !prefersReducedMotion();

  return (
    <div
      key={String(selected) + "|" + String(search || "")}
      style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 16,
         maxHeight: "88%",
                overflowY: "auto", scrollbarWidth: "thin",
     }}>
     {filtered
  .filter(p => p?.status !== "unavailable")
  .map((p, i) => (
    <ProductCard key={p.id} product={p} index={i} animate={deal} />
  ))}

    </div>
  );
};

export default ProductGrid;
